import TaxiCorporationOrderBillingsDownloadRequest, {
  TaxiCorporationOrderBillingsDownloadQueryParams,
} from "./taxi-corporation-order-billings-download.request";

const createQueryParams = (
  request: TaxiCorporationOrderBillingsDownloadRequest,
): TaxiCorporationOrderBillingsDownloadQueryParams => {
  return {
    billing_model: request.billingModel,
    billing_type: request.billingType,
    cargo_company: request.cargoCompany,
    date_since: request.dateSince,
    date_to: request.dateTo,
    exclude_cargo_company: request.excludeCargoCompany,
    human_id: request.humanId,
    order: request.order,
    passenger: request.passenger,
    plan_entry_human_ids: request.planEntryHumanIds,
    responsible_taxi: request.responsibleTaxi,
    status: request.status,
  };
};

const taxiCorporationOrderBillingsDownloadRequestFactory = {
  createQueryParams,
};

export default taxiCorporationOrderBillingsDownloadRequestFactory;
